// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowLink_root__GrVmG","primary":"ArrowLink_primary__1_gEJ","text":"ArrowLink_text__TJ6PQ"};